import * as PicabooConstants from '../common/PicabooConstants';
const { PRODUCT_SUBTYPES } = PicabooConstants;

export function isFabric(style) {
  return [].indexOf(style) !== -1;
}

export function isFoil(style) {
  return [].indexOf(style) !== -1;
}

const hideSubTypes = JSON.parse(process.env.bookSubTypesToHide).map((s) =>
  parseInt(s),
);
export function isDisabled(style) {
  return hideSubTypes.indexOf(style) !== -1;
}

export function isUltraThickPrint(style) {
  return false;
}

export function isPURBook(style) {
  return style === 0;
}
